import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingSection} from '@tempo/landing';
import {LandingParagraph} from '@tempo/landing';
import {useRouter} from 'next/router';
import {DeezerWidget} from '@app/components/Iframe/DeezerWidget';

const useSongCatcherPlaylist = (): readonly [string] => {
	const {locale} = useRouter();

	switch (locale) {
		case 'fr':
			return ['10517231282'];
		case 'de':
			return ['10517232362'];
		case 'pt-br':
			return ['10517232022'];
		default:
			return ['10496059222'];
	}
};

export const SongcatcherSong: FunctionComponent = () => {
	const {t} = useTranslation();
	const [playlist] = useSongCatcherPlaylist();

	return (
		<LandingSection
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'songcatcherlandingpage_title_topsongsofthemonth_standalone-web',
							{ns: 'songcatcher'},
						)}
					</LandingHeading>
					<LandingParagraph mt={10}>
						{t(
							'songcatcherlandingpage_text_topsongsofthemonth_standalone-web',
							{ns: 'songcatcher'},
						)}
					</LandingParagraph>
				</>
			}
		>
			<DeezerWidget type="playlist" id={playlist} />
		</LandingSection>
	);
};
